import { render, staticRenderFns } from "./form-unit-number.vue?vue&type=template&id=216c7ddd&scoped=true"
import script from "./form-unit-number.ts?vue&type=script&lang=ts&external"
export * from "./form-unit-number.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216c7ddd",
  null
  
)

export default component.exports